<template>
    <div>
       <h4 class="title">分享網址</h4>
       <div class="member_content">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td>網址</td>
                        <td>{{qr}}</td>
                    </tr>
                     <tr>
                        <td>QRCode</td>
                        <td>
                            <qr-code :text="qr"></qr-code>
                        </td>
                    </tr>
                </tbody>
            </table>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import {mapActions, mapGetters} from 'vuex'
import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

export default {
  name: 'Share',
  data () {
    return {
      userID: this.$store.getters.getUserID,
      qr: 'https://www.i80.com.tw/Register/' + localStorage.getItem('userId')
    }
  },
  mounted: function () {
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ])
  },
  computed: {
    ...mapGetters([
      'getUserID'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// Share.vue?c4e7b962